import React, { useState } from "react";
import api from "../lib/api";
import { PatientLanguageSelect } from "./PatientLanguageSelect";

export const PatientLanguagePreference = ({ patient, onSaved }) => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const update = async (preferred_language) => {
    setSaving(true); setError(""); setSaved(false);
    try {
      const r = await api.put(`/patients/${patient.patient_id}`, { preferred_language });
      onSaved(r.data.patient); setSaved(true);
    } catch {
      setError("Language was not saved. Please retry.");
    } finally { setSaving(false); }
  };
  return (
    <div className="mt-2 max-w-xs" data-testid="patient-language-preference">
      <PatientLanguageSelect value={patient.preferred_language} onChange={update} disabled={saving}
        testId="patient-preferred-language" label="Default patient language" />
      <div role="status" className="text-xs text-slate-500 mt-1" data-testid="patient-language-save-status">
        {saving ? "Saving…" : saved ? "Saved for future visits" : ""}
      </div>
      {error && <div role="alert" className="text-xs text-red-700" data-testid="patient-language-save-error">{error}</div>}
    </div>
  );
};